var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFanFrame1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.998,
    height: 16.999,
    viewBox: "0 0 15.998 16.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fan_ON_Frame1",
    "data-name": "Fan ON_Frame1",
    d: "M15.96,11.98a2.229,2.229,0,0,0-1.82-1.87l-3.43-.79a2.175,2.175,0,0,0-.76-.15,1.675,1.675,0,0,0,.14-.67,1.875,1.875,0,0,0-.22-.84,2.268,2.268,0,0,0,.71-.14l3.45-.71a2.226,2.226,0,0,0,1.86-1.83,3.775,3.775,0,0,0,.05-.85A5.8,5.8,0,0,0,15,1.07,2.128,2.128,0,0,0,13.57,0a1.081,1.081,0,0,0-.8.28A11.989,11.989,0,0,0,9.33,6.25a2.188,2.188,0,0,0-.13.71,1.851,1.851,0,0,0-.86-.27H8.32a1.81,1.81,0,0,0-.69.14,2.555,2.555,0,0,0-.14-.64L6.78,2.72A2.24,2.24,0,0,0,4.96.85,4.528,4.528,0,0,0,4.11.81a5.527,5.527,0,0,0-3.04.93A2.1,2.1,0,0,0,.01,3.17a1.081,1.081,0,0,0,.28.8A11.891,11.891,0,0,0,6.23,7.42a2.33,2.33,0,0,0,.6.13,1.688,1.688,0,0,0-.29.9,1.8,1.8,0,0,0,.25.88,2.074,2.074,0,0,0-.69.14l-3.45.71A2.226,2.226,0,0,0,.79,12.01a3.775,3.775,0,0,0-.05.85,5.618,5.618,0,0,0,.93,3.06A2.128,2.128,0,0,0,3.1,16.99a1.081,1.081,0,0,0,.8-.28,11.989,11.989,0,0,0,3.44-5.97,2.293,2.293,0,0,0,.13-.73,1.829,1.829,0,0,0,.83.25h.02A1.7,1.7,0,0,0,9.33,9.9a2.746,2.746,0,0,0,.13.65,11.9,11.9,0,0,0,3.3,6.05,1.023,1.023,0,0,0,.79.3A2.112,2.112,0,0,0,15,15.87a5.652,5.652,0,0,0,1-3.04A4.528,4.528,0,0,0,15.96,11.98Z",
    transform: "translate(-0.006 0.005)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFanFrame1);
export default __webpack_public_path__ + "static/media/fan_frame1.68cf83e824e80f403d8847fbec675df6.svg";
export { ForwardRef as ReactComponent };